<div class="border-b border-gray-200 mb-2">
	<div class="flex">
		<button
			*ngIf="showCustomizationTab"
			class="fb-product-tab px-4 py-3 text-sm font-medium cursor-pointer"
			(click)="setActiveTab('customization')"
			[class.active]="activeTab === 'customization'"
		>
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M3.49704 14.044L10.519 7.023C10.9863 6.56242 11.3573 6.01347 11.6104 5.40812C11.8634 4.80277 11.9935 4.15312 11.993 3.497C11.9931 2.18896 11.4796 0.933188 10.563 0L3.54004 7.024C3.07302 7.48451 2.70227 8.03333 2.44938 8.63851C2.1965 9.24368 2.06653 9.89311 2.06704 10.549C2.06704 11.922 2.61704 13.149 3.49704 14.045V14.044ZM20.504 9.941L13.481 16.963C13.0141 17.4235 12.6433 17.9724 12.3905 18.5775C12.1376 19.1827 12.0076 19.8321 12.008 20.488C12.008 21.848 12.558 23.089 13.438 23.985L20.46 16.963C20.9275 16.5025 21.2985 15.9536 21.5516 15.3482C21.8047 14.7428 21.9347 14.0931 21.934 13.437C21.934 12.064 21.384 10.837 20.504 9.941ZM20.46 7.037C20.9273 6.5766 21.2983 6.02783 21.5513 5.42264C21.8044 4.81746 21.9345 4.16796 21.934 3.512C21.934 2.152 21.384 0.912 20.504 0.015L3.54004 16.965C2.60422 17.8937 2.07431 19.1552 2.06626 20.4736C2.0582 21.792 2.57264 23.0599 3.49704 24L20.46 7.037Z" fill="#7D5A20"/>
			</svg>

			Customize This Product
		</button>
		<button
			class="fb-product-tab px-4 py-3 text-sm font-medium cursor-pointer"
			(click)="setActiveTab('description')"
			[class.active]="activeTab === 'description'"
		>
			About This Product
		</button>
	</div>
</div>
